// import consts from "@/consts.js";
import Request from './request';


async function fetch(data) {
    return Request('get', "api/requisition-pricing-logs/index", data);
}

export default {
    fetch,
};